import Authentication from './Authentication';

const authentication = new Authentication();

export default authentication;
